import { TFunction } from 'i18next';

export function getRequiredMessage(t: TFunction, name: string) {
	return t('required', {
		name,
	});
}
